import { ThemeName, ThemeObject, themes } from 'types/theme';
import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface LiveDisplaySettings {
  theme: ThemeObject;
  showQRCode: boolean;
  showSMSKeyword: boolean;
  showAmountRaised: boolean;
  showShoutouts: boolean;
  campaignId: string;
}

interface LiveDisplayState {
  campaigns: {
    [campaignId: string]: { liveDisplaySettings: LiveDisplaySettings };
  };
  hasDismissedSmallScreenWarning: boolean;
  setHasDismissedSmallScreenWarning: (hasDismissedSmallScreenWarning: boolean) => void;
  setLiveDisplaySettings: (liveDisplaySettings: LiveDisplaySettings) => void;
}

const useStore = create<LiveDisplayState>()(
  persist(
    (set, get) => ({
      campaigns: {
        default: {
          liveDisplaySettings: {
            campaignId: 'default',
            showAmountRaised: true,
            showQRCode: true,
            showSMSKeyword: true,
            showShoutouts: true,
            theme: themes[ThemeName.aurora],
          },
        },
      },
      hasDismissedSmallScreenWarning: false,
      setLiveDisplaySettings: (newSettings: LiveDisplaySettings) =>
        set({
          campaigns: {
            ...get().campaigns,
            [newSettings.campaignId]: {
              liveDisplaySettings: {
                ...newSettings,
              },
            },
          },
        }),

      setHasDismissedSmallScreenWarning: (hasDismissedSmallScreenWarning: boolean) =>
        set({ hasDismissedSmallScreenWarning }),
    }),
    {
      name: 'live-display-settings',
    },
  ),
);

export type { LiveDisplaySettings };
export { useStore };
